import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=0cfecf7f&scoped=true"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"
import style0 from "./CardPreview.vue?vue&type=style&index=0&id=0cfecf7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfecf7f",
  null
  
)

export default component.exports